import { App } from "@app/context"
import { out } from "@app/controller"

let nav: HTMLElement | null = null
let toggle: HTMLElement | null = null
let menu: HTMLElement | null = null
let scrim: HTMLElement | null = null
let menuLinks: HTMLAnchorElement[] = []
let isOpen = false

function open(): void {
  if (!nav || isOpen) return
  isOpen = true
  nav.classList.add("is-open")
  menu?.classList.add("is-open")
  scrim?.classList.add("is-open")
  toggle?.setAttribute("aria-expanded", "true")
  document.body.style.overflow = "hidden"
  App.scroller?.pause?.()
}

function close(): void {
  if (!isOpen) return
  isOpen = false
  nav?.classList.remove("is-open")
  menu?.classList.remove("is-open")
  scrim?.classList.remove("is-open")
  toggle?.setAttribute("aria-expanded", "false")
  document.body.style.overflow = ""
  App.scroller?.resume?.()
}

function onToggleClick(): void {
  if (isOpen) close()
  else open()
}

function onScrimClick(): void {
  close()
}

function onLinkClick(e: Event): void {
  e.preventDefault()
  const anchor = e.currentTarget as HTMLAnchorElement
  const href = anchor.getAttribute("href")
  if (!href) return
  close()
  setTimeout(() => out(href), 100)
}

export function initNav(): void {
  nav = document.getElementById("nav")
  if (!nav) return

  toggle = nav.querySelector(".nav-toggle")
  menu = document.getElementById("nav-menu")
  scrim = document.getElementById("nav-scrim")
  menuLinks = Array.from(document.querySelectorAll<HTMLAnchorElement>(".nav-menu__item a"))

  toggle?.addEventListener("click", onToggleClick)
  scrim?.addEventListener("click", onScrimClick)
  menuLinks.forEach(link => link.addEventListener("click", onLinkClick))
}

export function closeNav(): void {
  close()
}
